import { differenceInDays } from 'date-fns';
import React from 'react';
import styled from 'styled-components';
import { useObserver } from '../../../CodesThatsGottaGoSomewhereElse';
import { Colors, toRem } from '../../../ui';
import { TextButton } from '../../../ui/TextButton';
import { useResolve } from '../../Container';
import { Copy, Flexer } from '../../dashboard/elements/LayoutElements';
import { UpgradeButton } from '../../upgrade/UpgradeButton';
import { AccountModel } from '../AccountModel';

const Frame = styled.div<{ color?: string }>`
    position: relative;
    padding: .5rem 3%;
    margin: .5rem;
    border-radius: .5rem;
    background: ${p => p.color ?? 'rgba(0,0,0,0.2)'};   
    /* font-weight: 450; */
    user-select: none; 

    ${Copy} {
        color: white;
    }
    ${TextButton} {
        text-decoration: underline;
    }
`;

const FreeSlice = () => {
    const { plan } = useObserver(useResolve(AccountModel));
    if (!plan?.name?.includes('free')) return null;

    return <>
        <Frame>
            <Flexer flex="row" align="center" justify="space-between">
                <div>
                    <div>You are on the {plan.label} Plan.</div>
                    <div style={{ fontSize: '.75rem' }}>Usage limits apply.</div>
                </div>
                <UpgradeButton variant="common" />
            </Flexer>
        </Frame>
    </>;
};

const TrialSlice = () => {
    const { plan, trial } = useResolve(AccountModel);
    if (!plan?.name?.includes('trial')) return null;
    const now = new Date();
    const remaining = differenceInDays(trial.expiresAt, now);

    return <Frame color={remaining <= 5 ? Colors.mystery : null}>
        <Flexer flex="row" align="center" justify="space-between">
            <div>
                <div>Your space is on a Free Trial.</div>
                <div style={{ fontSize: toRem(12 / 16) }}>{remaining <= 5 ? 'Only ' : ''}{Math.max(0, remaining)} days remaining.</div>
            </div>
            <UpgradeButton variant="common" />
        </Flexer>
    </Frame>;
};

export const AdvertSlice = () => <>
    {/* <PromoSlice /> */}
    <FreeSlice />
    <TrialSlice />
</>;
